// Pages
import PushPage from './PushPage';

// Axios
import axios from 'axios';

// React
import React, { useEffect, useState, useRef } from 'react';
import 'react-tagsinput/react-tagsinput.css';

// Antd Mobile
import { Swiper, Toast } from 'antd-mobile'

// VK
import { Avatar, Snackbar } from '@vkontakte/vkui';
import baseTheme from '@vkontakte/vkui-tokens/themes/vkBase';
import { Icon28ErrorCircleOutline, Icon24ErrorCircleFillRed, Icon16ChainOutline, Icon24NotificationDisable } from '@vkontakte/icons';

// Telegram UI
import { AppRoot, Badge, Button, Blockquote, Cell, IconButton, Multiselectable, Navigation, Section, Spinner, Switch } from '@telegram-apps/telegram-ui';

// Icons
import { ReactComponent as PostsIcon } from "../assets/posts.svg";
import { ReactComponent as PostingIcon } from "../assets/posting.svg";
import { ReactComponent as ModeIcon } from "../assets/mode.svg";
import { ReactComponent as StreamsIcon } from "../assets/streams.svg";
import { ReactComponent as RSSIcon } from "../assets/rss.svg";
import { ReactComponent as RSSLinkIcon } from "../assets/rss_link.svg";
import { ReactComponent as TeamIcon } from "../assets/team.svg";
import { ReactComponent as StreamsOutlineIcon } from "../assets/streams_outline.svg";
import { ReactComponent as HelpIcon } from "../assets/help.svg";
import { ReactComponent as PlanIcon } from "../assets/plan.svg";
import { ReactComponent as FilterIcon } from "../assets/filter.svg";
import { ReactComponent as SourcesIcon } from "../assets/sources.svg";
import { ReactComponent as StyleIcon } from "../assets/style.svg";
import { ReactComponent as TimersIcon } from "../assets/timers.svg";
import { ReactComponent as OtherIcon } from "../assets/other.svg";
import { ReactComponent as TestIcon } from "../assets/test.svg";
import { ReactComponent as DigestIcon } from "../assets/digest.svg";
import { ReactComponent as TopicsIcon } from "../assets/topics.svg";

const tg = window.Telegram.WebApp;

const ChannelPageTest = ({ activePanel, setActivePanel, avatarSrc, selectedGroup, setGptLink, setGptMedia, setGptText, setSelectedGroup, premodePosts, setChannels, setGroups, setPremodePosts, selectedStreamIndex, setSelectedStreamIndex, stream, setStream }) => {
    const filteredPosts = premodePosts.filter(post => selectedGroup === null || post.id === selectedGroup.id);
    const streams = selectedGroup.streams;

    const swiperRef = useRef(null);

    const [switchChecked, setSwitchChecked] = useState(selectedGroup.active);
    const [loading, setLoading] = useState(false);

    const [testTitle, setTestTitle] = useState("");
    const [testImage, setTestImage] = useState([]);
    const [testLink, setTestLink] = useState("");
    const [testSummary, setTestSummary] = useState("");
    const [snackbar, setSnackbar] = useState(null);
    const [showNotifications, setShowNotifications] = useState(false);
    const [sendErros, setSendErros] = useState(Boolean(selectedGroup.send_erros));
    const [sendNf, setSendNf] = useState(Boolean(selectedGroup.send_nf));

    const openError = (text) => {
        setSnackbar(
            <Snackbar
                onClose={() => setSnackbar(null)}
                before={<Icon28ErrorCircleOutline fill="var(--vkui--color_icon_negative)" />}
            >
                {text}
            </Snackbar>,
        );
    };

    const gptTestDrive = async (s_tags, k_tags, n_tags, gptTemp, prompt_input, sign, postForce, token) => {
        console.log("gptTestDrive started");  // Лог для проверки вызова функции
        setLoading(true);

        try {
            const response = await axios.post('https://gmpeu.ru/get_summary', {
                urls: s_tags,
                keywords: k_tags,
                negative: n_tags,
                temp: gptTemp,
                prompt: prompt_input,
                sign: sign,
                force: postForce,
                tg_id: tg.initDataUnsafe.user.id,
                token: token
            });

            setLoading(false);
            const summary = response.data.summary.replace(/\\n/g, "\n");
            const title = response.data.title;
            const link = response.data.url;
            const image_url = response.data.image_url;

            setTestTitle(title);
            setTestLink(link);
            setTestImage(image_url);
            setTestSummary(summary);

            setGptLink(link);
            setGptMedia(image_url);
            setGptText(summary);

            setActivePanel('testgpt');

        } catch (error) {
            console.log(error)
            setLoading(false);
            openError("Не найдена подходящая статья, попробуйте изменить источники и/или ключевые слова");
        }
    };

    useEffect(() => {
        const backButtonHandler = () => {
            tg.HapticFeedback.impactOccurred('heavy');
            tg.HapticFeedback.notificationOccurred("success");
            if (showNotifications) {
                setShowNotifications(false);
                return;
            }
            setActivePanel('home');
        };

        if (activePanel === 'channel') {
            tg.BackButton.show();
            console.log(streams)
            tg.BackButton.onClick(backButtonHandler);
        }

        return () => {
            tg.BackButton.offClick(backButtonHandler);
        };
    }, [activePanel, showNotifications]);

    useEffect(() => {
        setShowNotifications(false);
        setSendErros(Boolean(selectedGroup.send_erros));
        setSendNf(Boolean(selectedGroup.send_nf));
    }, [selectedGroup.id, selectedGroup.send_erros, selectedGroup.send_nf]);


    const handleSwitchChange = (event) => {
        tg.HapticFeedback.impactOccurred('heavy');
        tg.HapticFeedback.notificationOccurred("success");
        setSwitchChecked(event.target.checked);

        const url = 'https://api.gmpapp.ru/save_active';

        try {
            fetch(url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ isActive: event.target.checked, group_id: selectedGroup.id })
            });

            if (setSelectedGroup) {
                setSelectedGroup(prev => ({ ...prev, active: event.target.checked }));
            }
        } catch (error) {
            console.error('Error active sending', error);
        }
    };

    const handleNotificationChange = async (field, checked) => {
        tg.HapticFeedback.impactOccurred('heavy');
        tg.HapticFeedback.notificationOccurred("success");

        const nextSendErros = field === 'send_erros' ? checked : sendErros;
        const nextSendNf = field === 'send_nf' ? checked : sendNf;

        setSendErros(nextSendErros);
        setSendNf(nextSendNf);

        try {
            const response = await fetch('https://api.gmpapp.ru/save_notifications', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    group_id: selectedGroup.id,
                    send_erros: nextSendErros,
                    send_nf: nextSendNf
                })
            });

            if (!response.ok) {
                console.error('Error:', response.status, response.statusText);
                return;
            }

            if (setSelectedGroup) {
                setSelectedGroup(prev => ({
                    ...prev,
                    send_erros: nextSendErros,
                    send_nf: nextSendNf
                }));
            }
        } catch (error) {
            console.error('Error notifications sending', error);
        }
    };

    const communityLink = () => {
        tg.HapticFeedback.impactOccurred('heavy');
        tg.HapticFeedback.notificationOccurred("success");
        tg.showPopup({
            title: "Выход из сервиса",
            message: "Вы покидаете сервис и переходите в Telegram-чат коммьюнити GiveMePublic. Там можно задать любой вопрос по настройкам и/или по работе. Перейти в чат?",
            buttons: [
                { id: 'ok', text: 'Перейти' },
                { id: 'cancel', type: 'cancel' },
            ]
        }, (buttonId) => {
            if (buttonId === 'cancel') {
                console.log("Действие отменено");
            } else if (buttonId === 'ok') {
                tg.openTelegramLink('https://t.me/ask4gmp');
                tg.close();
            }
        });
    };

    const handleStream = (index, panel) => {
        console.log(`Type of streams[${index}]:`, typeof streams[index]);
        console.log(`Value of streams[${index}]:`, JSON.stringify(streams[index], null, 2));

        // Модифицируем объект напрямую, не создавая клон, чтобы позволить мутации
        const newStream = streams[index];
        newStream.id = index;

        setStream(newStream);
        setActivePanel(panel);
    };

    console.log('Streams:', streams[0])
    console.log('SelectedGroup:', selectedGroup)

    if (showNotifications) {
        return (
            <div className="wrapperUI">
                <AppRoot platform='ios'>
                    <Section className='sectionChannelOther' header="Уведомления">
                        <Cell
                            Component="label"
                            before={<Icon24ErrorCircleFillRed className="SettingsItemIcon" />}
                            after={<Multiselectable name="send_erros" checked={sendErros} onChange={(event) => handleNotificationChange('send_erros', event.target.checked)} />}
                            multiline
                        >
                            Не уведомлять об ошибках
                        </Cell>
                        <Cell
                            Component="label"
                            before={<Icon28ErrorCircleOutline className="SettingsItemIcon" />}
                            after={<Multiselectable name="send_nf" checked={sendNf} onChange={(event) => handleNotificationChange('send_nf', event.target.checked)} />}
                            multiline
                        >
                            Не уведомлять, если новости не найдены
                        </Cell>
                    </Section>
                    {snackbar}
                </AppRoot>
            </div>
        );
    }

    return (
        <div className="wrapperUI">
            <AppRoot platform='ios'>
                <Section className='sectionChannel'>
                    <Cell
                        className='streamsIcon'
                        hovered={false}
                        before={<Avatar className="channelAvatar" size={48} initials={selectedGroup.name.substring(0, 2)} src={avatarSrc} />}
                        after={<IconButton onClick={communityLink} mode="gray" size="m"><HelpIcon /></IconButton>}
                        subtitle={
                            selectedGroup.id.toString().startsWith('-200')
                                ? `RSS-лента`
                                : `${selectedGroup.members_count} подписчиков`
                        }
                    >
                        {selectedGroup.name}
                    </Cell>
                    <Cell
                        Component="label"
                        className="settingsItem"
                        subtitle={
                            streams[0].sources == 0 && streams[0].timer == 0
                                ? "Добавьте источники и установите расписание"
                                : streams[0].sources == 0
                                    ? "Добавьте источники"
                                    : streams[0].timer == 0
                                        ? "Установите расписание"
                                        : undefined
                        }
                        before={<PostingIcon className='SettingsItemIcon' />}
                        after={
                            <Switch
                                className='postingSwitch'
                                onChange={handleSwitchChange}
                                checked={switchChecked && !(streams[0].sources == 0 || streams[0].timer == 0)}
                                disabled={streams[0].sources == 0 || streams[0].timer == 0}
                            />
                        }
                        multiline
                    >
                        Постинг
                    </Cell>
                    <Cell onClick={() => { tg.HapticFeedback.impactOccurred('heavy'); tg.HapticFeedback.notificationOccurred("success"); setActivePanel('posting'); }} className='settingsItem' before={<ModeIcon className='SettingsItemIcon' />} after={<Navigation>{streams[0].premode ? "Премодерация" : "Автопостинг"}</Navigation>}>Режим</Cell>
                    <Cell
                        onClick={() => { tg.HapticFeedback.impactOccurred('heavy'); tg.HapticFeedback.notificationOccurred("success"); setActivePanel('posts'); }}
                        className='settingsItem postsItem'
                        before={<PostsIcon className='SettingsItemIcon' />}
                        after={
                            <Navigation>
                                {filteredPosts.length > 0 && <Badge type="number">{filteredPosts.length}</Badge>}
                            </Navigation>
                        }
                    >
                        Публикации
                    </Cell>
                </Section>
                {selectedGroup.id.toString().startsWith('-200') ?
                    <Section className='sectionChannel' header="Настройки RSS">
                        <Cell onClick={() => { tg.HapticFeedback.impactOccurred('heavy'); tg.HapticFeedback.notificationOccurred("success"); setActivePanel('rss'); }} className='settingsItem' before={<RSSIcon className='SettingsItemIcon' />} after={<Navigation />}>Параметры</Cell>
                        <Cell onClick={() => { tg.HapticFeedback.impactOccurred('heavy'); tg.HapticFeedback.notificationOccurred("success"); Toast.show({ icon: 'success', content: 'Ссылка скопирована' }); navigator.clipboard.writeText(`https://api.gmpapp.ru/rss_feed/${selectedGroup.id}`); }} className='settingsItem copyLink' before={<RSSLinkIcon className='SettingsItemIcon' />} after={<Icon16ChainOutline />}>Ссылка на RSS</Cell>
                    </Section> : null
                }
                <Section className='sectionChannel' header="Управление">
                    <Cell onClick={() => { tg.HapticFeedback.impactOccurred('heavy'); tg.HapticFeedback.notificationOccurred("success"); setActivePanel('streams'); }} className='settingsItem' before={<StreamsIcon className='SettingsItemIcon' />} after={<Navigation />}>Рубрики</Cell>
                    <Cell onClick={() => { tg.HapticFeedback.impactOccurred('heavy'); tg.HapticFeedback.notificationOccurred("success"); setActivePanel('team'); }} className='settingsItem' before={<TeamIcon className='SettingsItemIcon' />} after={<Navigation />}>Команда</Cell>
                    <Cell onClick={() => { tg.HapticFeedback.impactOccurred('heavy'); tg.HapticFeedback.notificationOccurred("success"); setShowNotifications(true); }} className='settingsItem' before={<Icon24NotificationDisable className='SettingsItemIcon' />} after={<Navigation />}>Уведомления</Cell>
                    {/* <Cell className='settingsItem soonItem' before={<PlanIcon className='SettingsItemIcon' />} after={<Navigation><Badge type="number">СКОРО</Badge></Navigation>}>Контент-план</Cell> */}
                </Section>
                <Swiper
                    indicatorProps={{
                        className: 'my-indicator',
                        style: {
                            '--active-dot-color': 'red', // меняем цвет активной точки
                            '--dot-color': 'gray',       // обычные точки
                        },
                    }}
                    ref={swiperRef}
                    defaultIndex={selectedStreamIndex}
                    indicator={(total, current) => (
                        total > 1 ? (
                            <div style={{ display: 'flex', justifyContent: 'center', marginTop: 10 }}>
                                {Array(total).fill(0).map((_, index) => (
                                    <div
                                        key={index}
                                        style={{
                                            width: 10,
                                            height: 10,
                                            borderRadius: '50%',
                                            background: current === index ? baseTheme.colorAccentBlue.normal : baseTheme.colorTabbarTextInactive.active,
                                            margin: '0 5px',
                                            cursor: 'pointer'
                                        }}
                                        onClick={() => {
                                            if (swiperRef.current) {
                                                setSelectedStreamIndex(index);
                                                swiperRef.current.swipeTo(index);
                                            }
                                        }}
                                    />
                                ))}
                            </div>
                        ) : null
                    )}
                    onIndexChange={(index) => setSelectedStreamIndex(index)}
                    style={{ '--track-padding': ' 0 0 6px', userSelect: 'none' }}
                >
                    {streams.map((stream, index) => (
                        <Swiper.Item key={index}>
                            <Section className='sectionChannel' header={`Параметры рубрики «${stream.name}»`}>
                                <Cell onClick={() => { tg.HapticFeedback.impactOccurred('heavy'); tg.HapticFeedback.notificationOccurred("success"); handleStream(index, 'sources'); }} className='settingsItem' before={<SourcesIcon className='SettingsItemIcon' />} after={stream.sources == 0 ? <> <Icon24ErrorCircleFillRed className='emptyWarning' /> <Navigation /> </> : <Navigation />}>Источники</Cell>
                                <Cell onClick={() => { tg.HapticFeedback.impactOccurred('heavy'); tg.HapticFeedback.notificationOccurred("success"); handleStream(index, 'filter'); }} className='settingsItem' before={<FilterIcon className='SettingsItemIcon' />} after={<Navigation />}>Фильтрация</Cell>
                                <Cell onClick={() => { tg.HapticFeedback.impactOccurred('heavy'); tg.HapticFeedback.notificationOccurred("success"); handleStream(index, 'style'); }} className='settingsItem' before={<StyleIcon className='SettingsItemIcon' />} after={<Navigation />}>Стиль постов</Cell>
                                {selectedGroup.supergroup ?
                                    <Cell onClick={() => { tg.HapticFeedback.impactOccurred('heavy'); tg.HapticFeedback.notificationOccurred("success"); handleStream(index, 'topics'); }} className='settingsItem' before={<TopicsIcon className='SettingsItemIcon' />} after={<Navigation />}>Постить в группу</Cell> : null
                                }
                                <Cell onClick={() => { tg.HapticFeedback.impactOccurred('heavy'); tg.HapticFeedback.notificationOccurred("success"); handleStream(index, 'digest'); }} className='settingsItem' before={<DigestIcon className='SettingsItemIcon' />} after={<Navigation><Badge type="number">NEW!</Badge></Navigation>}>Дайджест</Cell>
                                <Cell onClick={() => { tg.HapticFeedback.impactOccurred('heavy'); tg.HapticFeedback.notificationOccurred("success"); handleStream(index, 'timers'); }} className='settingsItem' before={<TimersIcon className='SettingsItemIcon' />} after={stream.timer == 0 ? <> <Icon24ErrorCircleFillRed className='emptyWarning' /> <Navigation /> </> : <Navigation />}>Расписание</Cell>
                                <Cell onClick={() => { tg.HapticFeedback.impactOccurred('heavy'); tg.HapticFeedback.notificationOccurred("success"); handleStream(index, 'other'); }} className='settingsItem' before={<OtherIcon className='SettingsItemIcon' />} after={<Navigation />}>Дополнительно</Cell>
                            </Section>
                        </Swiper.Item>
                    ))}
                </Swiper>
                {snackbar}
            </AppRoot>
        </div>
    );
};

export default ChannelPageTest;
